module.exports = __webpack_public_path__ + "img/client-3.jpg?3562128abdbc7f75e9d3bf2e049caa55";